import { render, staticRenderFns } from "./RingNotification.vue?vue&type=template&id=70d8d277&scoped=true&"
import script from "./RingNotification.vue?vue&type=script&lang=js&"
export * from "./RingNotification.vue?vue&type=script&lang=js&"
import style0 from "./RingNotification.vue?vue&type=style&index=0&id=70d8d277&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d8d277",
  null
  
)

export default component.exports